import { defineStyleConfig } from '@chakra-ui/react';

const formLabelTheme = defineStyleConfig({
  baseStyle: {
    textAlign: 'left',
    _disabled: {
      opacity: 1,
    },
  },
  variants: {
    outline: {
      mb: '5px',
      color: 'leaseEndBlue',
      fontWeight: 'semibold',
      letterSpacing: '1px',
      textTransform: 'uppercase',
    },
    clay: {
      mb: '5px',
      color: 'white',
      fontWeight: 'semibold',
      letterSpacing: '1px',
    },
  },
});

export default formLabelTheme;
